// analyticsLoader.js

// Функция для динамической загрузки Google Analytics (gtag.js)
export function loadGA(gaId = 'G-5DJLQW5BZK') {
  // Если скрипт уже загружен, выходим
  if (document.getElementById('ga-script')) return;

  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;

  // Добавляем скрипт в head
  document.head.appendChild(script);

  // Инициализируем GA после загрузки скрипта
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId);
  };
}

// Функция для динамической загрузки Google Tag Manager
export function loadGTM(gtmId = 'GTM-PGWWQ4VJ') {
  // Если скрипт уже загружен, выходим
  if (document.getElementById('gtm-script')) return;

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // Добавляем также noscript-iframe (опционально)
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.appendChild(noscript);
}
